import { useEffect, useState } from 'react';
import { State } from '@progress/kendo-data-query';
import PopupMenu, { popupMenu as MenuList } from '../components/popupMenu';
import { PageChangeEvent, Pager } from '@progress/kendo-react-data-tools';
import {
  DefaultGridSettings,
  DefaultPagerSettings
} from '../constants/grid-settings';
import { formatDateToDDMMYYYY } from '../utils/date';
import { convertToStatusName } from '../utils/template-status-helper';
import { GameResponse } from '../types/responses/game-response';

export interface CardViewDataStateChangeEvent {
  dataState: State;
}

export interface GamesManagementCardViewProps extends State {
  data?: GameResponse[];
  onDelete?: (id: number) => void;
  onDataStateChange?: (event: CardViewDataStateChangeEvent) => void;
  total?: number;
}

export const GamesManagementCardView = ({
  data,
  onDelete,
  total = 0,
  ...props
}: GamesManagementCardViewProps) => {
  const [menuList, setMenuList] = useState<MenuList[]>([]);
  const handlePageChange = (event: PageChangeEvent) => {
    raiseDataStateChangeEvent({ skip: event.skip, take: event.take });
  };

  /**
   * Raise the Grid DataState change event. I.e. filters have changed.
   * @param moreData
   */
  const raiseDataStateChangeEvent = (moreData: State) => {
    props.onDataStateChange?.({
      dataState: { ...getDataState(), ...moreData }
    });
  };

  const getDataState = () => {
    return {
      filter: props.filter,
      sort: props.sort,
      skip: props.skip,
      take:
        props.take !== undefined ? props.take : DefaultGridSettings.pageSize,
      group: props.group
    };
  };

  const generatePopupMenu = () => {
    let newMenus: MenuList[] = [
      { classIcon: 'delete', textMenu: 'Delete', textClass: '' }
    ];

    setMenuList(newMenus);
  };

  const onMenuSelected = async (id: number, menu: MenuList) => {
    if (menu.textMenu === 'Delete') {
      if (onDelete) {
        onDelete(id);
      }
    }
  };

  useEffect(() => {
    generatePopupMenu();
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        minHeight: 0,
        overflow: 'hidden'
      }}>
      <div
        className={'row grid-card-library'}
        style={{
          flexGrow: 1,
          overflow: 'auto'
        }}>
        {data &&
          data.map((lib, index) => {
            return (
              <div
                className={'col-xs-12 col-sm-12 col-md-6 d-flex'}
                key={index}>
                <div
                  className={'card mt-4 card-view card-library flex-grow-1 '}>
                  <div className={'d-flex p-2'}>
                    <div className={'p-2'}>
                      <div
                        className={`avatar ${
                          Boolean(lib.logoUrl) ? '' : 'bg-primary'
                        }`}>
                        {Boolean(lib.logoUrl) ? (
                          <img
                            className={'w-100 h-100 rounded-full'}
                            src={lib.logoUrl}
                            alt="logo"
                          />
                        ) : (
                          <i className={'bi bi-person icon'} />
                        )}
                      </div>
                    </div>
                    <div style={{ flex: 1 }}>
                      <div className={'card-body-right p-2'}>
                        <div
                          className={
                            'd-flex justify-content-between align-items-center'
                          }>
                          <h3 className={'title link-primary'}>{lib?.name}</h3>

                          <PopupMenu
                            id={lib.id!}
                            menus={menuList}
                            onMenuSelected={onMenuSelected}></PopupMenu>
                        </div>
                        <hr className={'mt-0'} />
                        <div className={'d-flex flex-wrap'}>
                          <div>
                            <span>Created :</span>{' '}
                            <span className={'ml-1'}>
                              {formatDateToDDMMYYYY(lib?.createdDateUtc!)}
                            </span>
                          </div>
                        </div>
                        <div className={'d-flex flex-wrap'}>
                          <div>
                            <span>Updated : </span>
                            <span className={'ml-1'}>
                              {formatDateToDDMMYYYY(lib?.modifiedDateUtc!)}
                            </span>
                          </div>
                        </div>
                        <div className={'d-flex flex-wrap'}>
                          <div>
                            <span>Status :</span>{' '}
                            <span className={'ml-1 text-success'}>
                              {convertToStatusName(lib?.status!)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
      <div className={'row mt-3'}>
        <div className={'col-md-12'}>
          <Pager
            onPageChange={handlePageChange}
            total={total}
            take={
              props.take !== undefined
                ? props.take
                : DefaultGridSettings.pageSize
            }
            skip={props.skip !== undefined ? props.skip : 0}
            {...DefaultPagerSettings}
          />
        </div>
      </div>
    </div>
  );
};
